import { render } from "./OvdsUpload.vue?vue&type=template&id=a0864970"
import script from "./OvdsUpload.vue?vue&type=script&lang=js"
export * from "./OvdsUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__